exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-9fb3f446] {\n    color: #232323;\n    font-size: 24px;\n    text-align: center;\n}\n", ""]);

// exports
